import { Typography } from '@mui/material';
import DrilldownDialog from './DrilldownDialog';
import { salesCycleAdmissionsUrl } from './salesCycleAdmissions';
import { Date1, Stack2, digits, fmt } from './drilldownCells';

// The popup behind a person's "Admissions" count on Sales Cycle Length: the admissions that make up the number, one row each -
// who the student is, the course and program, the lead they came from, when that lead was assigned, when they were admitted
// (= the day the first real payment arrived, holds skipped - the OGD point tracker's rule) and how many days it took (the page's
// average is the average of this column), when the record was entered, who enrolled them and the CRO.
// Longest cycles first: they are what pulls the average up.
const COLUMNS = [
  { key: 'name', label: 'Student', sort: (r) => (r.name || '').toLowerCase(), render: (r) => <Stack2 top={r.name} bottom={r.mobile} />, csv: (r) => r.name },
  { key: 'admnNo', label: 'Admn no', sort: (r) => String(r.admnNo || ''), render: (r) => <Typography variant="body2" fontWeight={600}>{r.admnNo || '-'}</Typography>, csv: (r) => r.admnNo },
  { key: 'course', label: 'Course', sort: (r) => (r.course || '').toLowerCase(), render: (r) => <Stack2 top={r.course} bottom={r.program} />, csv: (r) => r.course },
  { key: 'lead', label: 'Lead', sort: (r) => (r.leadName || '').toLowerCase(), render: (r) => <Stack2 top={r.leadName} bottom={r.leadSource} />, csv: (r) => r.leadName },
  { key: 'assignedOn', label: 'Lead assigned', sort: (r) => r.assignedOn || '', render: (r) => <Date1 value={r.assignedOn} />, csv: (r) => fmt(r.assignedOn) },
  { key: 'admittedOn', label: 'Admitted', sort: (r) => r.admittedOn || '', render: (r) => <Date1 value={r.admittedOn} dateOnly />, csv: (r) => r.admittedOn },
  {
    key: 'cycleDays', label: 'Cycle (days)', align: 'right', sort: (r) => r.cycleDays,
    render: (r) => <Typography variant="body2" fontWeight={700} sx={{ fontVariantNumeric: 'tabular-nums' }}>{r.cycleDays}</Typography>, csv: (r) => r.cycleDays,
  },
  { key: 'enrolledOn', label: 'Enrolled on', sort: (r) => r.enrolledOn || '', render: (r) => <Date1 value={r.enrolledOn} dateOnly />, csv: (r) => fmt(r.enrolledOn) },
  { key: 'enrolledBy', label: 'Enrolled by', sort: (r) => (r.enrolledBy || '').toLowerCase(), render: (r) => <Typography variant="body2">{r.enrolledBy || '-'}</Typography>, csv: (r) => r.enrolledBy },
  { key: 'cro', label: 'CRO', sort: (r) => (r.cro || '').toLowerCase(), render: (r) => <Typography variant="body2">{r.cro || '-'}</Typography>, csv: (r) => r.cro },
];

const searchText = (r) => [r.name, r.admnNo, digits(r.mobile), r.mobile, r.course, r.program, r.leadName, r.leadSource, r.enrolledBy, r.cro]
  .filter(Boolean).join(' ').toLowerCase();

const SalesCycleAdmissionsDialog = ({ request, onClose }) => {
  const { userName, month } = request;
  return (
    <DrilldownDialog
      url={salesCycleAdmissionsUrl(request)}
      title="Admissions"
      chips={[userName, month.format('MMMM YYYY')]}
      dataChips={(d) => [d.averageDays !== null && d.averageDays !== undefined ? `Average ${d.averageDays} days` : null]}
      columns={COLUMNS}
      searchText={searchText}
      searchLabel="Search these admissions"
      searchPlaceholder="Search student, admn no, course, lead"
      emptyText="No admissions."
      rowKey={(r) => r.enrollmentId}
      csvName={`Admissions_${(userName || 'person').replace(/\W+/g, '_')}_${month.format('YYYY-MM')}.csv`}
      onClose={onClose}
    />
  );
};

export default SalesCycleAdmissionsDialog;
